import { HttpEvent } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { catchError, map } from 'rxjs';
import { GeneralDynamicContent } from 'src/app/shared/entities/general-dynamic-content';
import { DynamicResourceService } from 'src/app/shared/services/dynamic-resource.service';

@Component({
  selector: 'app-modale-preview',
  templateUrl: './modale-preview.component.html',
  styleUrls: ['./modale-preview.component.css']
})
export class ModalePreviewComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: GeneralDynamicContent, private dynamicResourceService: DynamicResourceService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadHTML();
    this.loadVideos();
    this.loadDocuments();
  }

  getContent(contentRef: string) {
    return this.data?.content.find((el: any) => el.ref === contentRef)?.content;
  }

  getType(contentRef: string) {
    return this.data?.content.find((el: any) => el.ref === contentRef).type;
  }

  loadHTML() {
    setTimeout(() => {
      let htmlElements = document.getElementsByClassName('html-content');
      Array.from(htmlElements).forEach((el) => {
        this.displayHTML(el.id);
      })
    }, 100)
  }

  displayHTML(ref: string) {
    let content = this.getContent(ref);

    let div = document.getElementById(ref);
    if (div)
      div.innerHTML = content;
  }

  loadVideos() {
    setTimeout(() => {
      let videoElements = document.getElementsByClassName('iframe');
      Array.from(videoElements).forEach((el) => {
        this.embedYouTubeVideo(el.id);
      })
    }, 100)
  }

  loadDocuments() {
    setTimeout(() => {
      let docElements = document.getElementsByClassName('document');
      Array.from(docElements).forEach((el) => {
        this.setDocument(el.id);
      })
    }, 100)
  }

  setDocument(ref: string) { // elementRef id = documentId
    this.dynamicResourceService.findById(ref).pipe(
      map((url: string) => {
        const docSrc = url;
        if (docSrc) {
          // Create iframe element
          const div = document.createElement('a');
          div.className = 'doc-element';
          div.innerHTML = 'Ouvrir le document';
          div.href = docSrc;
          div.target = '_blank';

          // Append iframe to the div with id 'iframe'
          const divContainer = document.getElementById(ref);
          if (divContainer) {
            divContainer.innerHTML = ''; // Clear any existing content
            divContainer.appendChild(div);
          }
        }

      }),
      catchError((error) => {
        let err: string = error?.error ? error?.error.text : error.text;
        if (err) {
          const div = document.createElement('a');
          div.className = 'doc-element';
          div.innerHTML = 'Ouvrir le document';
          div.href = err;
          div.target = '_blank';

          // Append iframe to the div with id 'iframe'
          const divContainer = document.getElementById(ref);
          if (divContainer) {
            divContainer.innerHTML = ''; // Clear any existing content
            divContainer.appendChild(div);
          }
        }
        throw error;
      })
    ).subscribe()
  }

  embedYouTubeVideo(ref: string): void {
    // Extract video ID from YouTube URL
    const videoSrc = this.transformYTUrl(this.getContent(ref));

    if (videoSrc) {
      // Create iframe element
      const iframe = document.createElement('iframe');
      iframe.src = videoSrc;
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope;';
      iframe.allowFullscreen = true;
      iframe.className = 'iframe-element';

      // Append iframe to the div with id 'iframe'
      const iframeContainer = document.getElementById(ref);
      if (iframeContainer) {
        iframeContainer.innerHTML = ''; // Clear any existing content
        iframeContainer.appendChild(iframe);
      }
    }
  }

  transformYTUrl(url: string) {
    return `https://youtube.com/embed/${this.getYouTubeVideoId(url)}`
  }

  // Function to extract YouTube video ID from the link
  private getYouTubeVideoId(link: string): string | null {
    // Regular expression to extract video ID from various YouTube link formats
    const regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = link.match(regex);
    return match ? match[1] : null;
  }

}
